import CustomCampainCreatePage from "./CustomCampainCreatePage";

export default CustomCampainCreatePage;
